import { CssBaseline, GlobalStyles, ThemeProvider } from "@mui/material"
import { captureException } from "@sentry/react"
import {
  QueryCache,
  QueryClient,
  QueryClientProvider,
} from "@tanstack/react-query"
import { ReactQueryDevtools } from "@tanstack/react-query-devtools"
import { StrictMode } from "react"
import App from "./App"
import { ToastProvider } from "./components/Toast"
import { useCapClient } from "./hooks/useCapClient"
import { TRPCProvider } from "./utils/cap"
import { theme } from "./utils/theme"

const inputGlobalStyles = <GlobalStyles styles={{ a: { color: "inherit" } }} />

const queryClient = new QueryClient({
  queryCache: new QueryCache({
    // inspiration for the following code:
    // https://tkdodo.eu/blog/breaking-react-querys-api-on-purpose#a-bad-api
    onError: (error, query) => {
      captureException(error, {
        tags: {
          queryKey: query.queryKey.toString(),
        },
      })
    },
  }),
})

export const AppProviders: React.FC = () => {
  const capClient = useCapClient()
  return (
    <StrictMode>
      <TRPCProvider trpcClient={capClient} queryClient={queryClient}>
        <QueryClientProvider client={queryClient}>
          {import.meta.env.DEV && <ReactQueryDevtools />}
          <ThemeProvider theme={theme}>
            <CssBaseline enableColorScheme />
            {inputGlobalStyles}
            <ToastProvider>
              <App />
            </ToastProvider>
          </ThemeProvider>
        </QueryClientProvider>
      </TRPCProvider>
    </StrictMode>
  )
}
